function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 49,
  height: 49,
  stroke: "#2D577D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5905 20.0131L31.0518 15.75L35.9745 15.75L38.4358 20.0131L35.9745 24.2763L31.0518 24.2763L28.5905 20.0131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5905 20.0131L13.0518 15.75L17.9745 15.75L20.4358 20.0131L17.9745 24.2763L13.0518 24.2763L10.5905 20.0131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5905 25.0131L22.0518 20.75L26.9745 20.75L29.4358 25.0131L26.9745 29.2763L22.0518 29.2763L19.5905 25.0131Z",
  fill: "#047E2E",
  fillOpacity: 0.5,
  stroke: "#047E2E"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5905 30.5131L31.0518 26.25L35.9745 26.25L38.4358 30.5131L35.9745 34.7763L31.0518 34.7763L28.5905 30.5131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5905 30.5131L13.0518 26.25L17.9745 26.25L20.4358 30.5131L17.9745 34.7763L13.0518 34.7763L10.5905 30.5131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5905 36.0131L22.0518 31.75L26.9745 31.75L29.4358 36.0131L26.9745 40.2763L22.0518 40.2763L19.5905 36.0131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5905 14.5131L22.0518 10.25L26.9745 10.25L29.4358 14.5131L26.9745 18.7763L22.0518 18.7763L19.5905 14.5131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

function SvgStarBurst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    className: "bg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBurst);
export default __webpack_public_path__ + "static/media/starBurst.2fe634b5.svg";
export { ForwardRef as ReactComponent };